export default {"src":"/uk/_next/static/media/spot-tick.72cffefd.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};